// extracted by mini-css-extract-plugin
module.exports = {"small":"J1nd","medium":"J1akj","large":"J1aj5","radialProgress":"J1akl","spin":"J1bv"};